/**
 * @file uniframe 注册弹窗
 */

import { ready as uniframeReady, getByGlobalsComponent } from '@/hooks/uniframe';

// 注册弹窗实例
let registerRef;
// 注册弹窗 DOM
let registerDOM;

// 注册弹窗状态
const stateMap = {
    INIT: 'init',
    LOADING: 'loading',
    FINISH: 'finish',
};
let status = stateMap.INIT;

/** ****** 临时代码 Start ******* */
// 因为 uniframe 的注册弹窗目前没有移动端样式，所以在移动端暂时使用缩放来设置尺寸
// 如将来 uniframe 的注册弹窗支持移动端样式后，请去掉临时代码
// uniframe 注册弹窗支持移动端样式联系人: @mzry.li
/**
 * 设置移动端 class
 *
 * @param {DOM} registerWrapDom 注册弹窗容器
 */
const setMobileClass = (registerWrapDom) => {
    const { isMobile } = window.sfe;
    // 屏幕宽度
    const { innerHeight: winHeight } = window;
    // 目标高度
    const distHeight = Math.floor(winHeight * 0.8);
    // 注册弹窗移动端尺寸
    const registerModalHeight = 664;
    // 最小缩放比例
    const minScaleVal = 0.6;
    if (isMobile && distHeight < registerModalHeight) {
        const result = Math.floor(Math.max(distHeight / registerModalHeight, minScaleVal) * 100);
        registerWrapDom.className = `mobile-scale-${result}`;
    }
};
/** ****** 临时代码 End ******* */

// 初始化注册弹窗挂载 DOM
const initRegisterWrapDom = (registerId) => {
    const registerWrapDom = document.createElement('div');
    registerWrapDom.id = registerId;
    setMobileClass(registerWrapDom);
    document.body.appendChild(registerWrapDom);
    return registerWrapDom;
};

// 初始化注册弹窗
const initUniframe = ({ onClose, onSuccess, onReady }) => {
    const registerId = '__bybit_uniframe_register__';

    // 初始化 DOM
    registerDOM = initRegisterWrapDom(registerId);

    return uniframeReady().then(async () => {
        const ins = await getByGlobalsComponent('registerLoginModal', {}, registerId);
        ins?.update({ isRegisterModal: true, onHideModal: onClose, registerSuccessCallBack: onSuccess });
        registerRef = ins;
        onReady?.();
    });
};

// 销毁注册弹窗
const destroy = () => {
    registerRef?.update({
        visible: false,
    });
    status = stateMap.INIT;

    if (registerDOM) {
        document.body.removeChild(registerDOM);
    }
};

// 回调函数列表
const closeHandlerList = new Set();
const successHandlerList = new Set();
const readyHandlerList = new Set();

// 注册弹窗显示/隐藏函数
const updateRegisterVisible = (visible) => {
    registerRef?.update({ visible });
};
// 注册弹窗显示函数
const show = () => updateRegisterVisible(true);
// 注册弹窗隐藏函数
const close = () => updateRegisterVisible(false);

// 添加函数工厂函数
const addHandlerFactory = (list) => (handler) => {
    list.add(handler);
};
// 关闭回调
const onClose = addHandlerFactory(closeHandlerList);
// 注册成功回调
const onSuccess = addHandlerFactory(successHandlerList);
// 注册弹窗准备就绪回调
const onReady = addHandlerFactory(readyHandlerList);

// 函数队列工厂函数
const emitHandlerFactory = (list, beforeHandler = null, afterHandler = null) => () => {
    if (typeof beforeHandler === 'function') {
        beforeHandler();
    }

    if (list.size) {
        list.forEach((handler) => {
            if (typeof handler === 'function') {
                handler();
            }
        });
    }

    if (typeof afterHandler === 'function') {
        afterHandler();
    }
};

export const useRegister = () => {
    if (status === stateMap.INIT) {
        status = stateMap.LOADING;
        initUniframe({
            onSuccess: emitHandlerFactory(
                successHandlerList,
                null,
                () => {
                    const url = new URL(window.location.href);
                    url.searchParams.delete('ref');
                    window.location.replace(url.href);
                },
            ),
            onClose: emitHandlerFactory(
                closeHandlerList,
                () => close(),
            ),
            onReady: emitHandlerFactory(
                readyHandlerList,
                () => {
                    status = stateMap.FINISH;
                },
            ),
        });
    }

    return {
        show,
        close,
        destroy,
        onClose,
        onSuccess,
        onReady,
    };
};
